import React from 'react';

class LinkedInAuthSuccess extends React.Component {
    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const accessToken = params.get("accessToken");
        const personUrn = params.get("personUrn");

        if (accessToken && personUrn) {
            localStorage.setItem("linkedinAccessToken", accessToken);
            localStorage.setItem("linkedinPersonUrn", personUrn);
            const lastViewedCertificateUrl = localStorage.getItem("lastViewedCertificateUrl") || "/";
            window.location.href = lastViewedCertificateUrl + "?linkedinAuthSuccess=true";
        } else {
            const lastViewedCertificateUrl = localStorage.getItem("lastViewedCertificateUrl") || "/";
            window.location.href = lastViewedCertificateUrl + "?linkedinAuthSuccess=false";
        }
    }

    render() {
        return <div>Processing LinkedIn authentication...</div>;
    }
}
export default LinkedInAuthSuccess;